import { environment } from 'environments/environment';
import SuperTokens from 'supertokens-web-js/lib/build/supertokens';
import Session from 'supertokens-web-js/recipe/session';

let isSuperTokensInitialised = false;

export function initSuperTokens(): void {
    if (isSuperTokensInitialised) {
        return;
    }

    SuperTokens.init({
        appInfo: {
            appName: environment.supertokens.appName,
            apiDomain: environment.supertokens.apiDomain,
            apiBasePath: environment.supertokens.apiBasePath,
        },
        recipeList: [Session.init()],
    });

    isSuperTokensInitialised = true;
}

export async function preflightSessionRefresh(): Promise<void> {
    initSuperTokens();

    try {
        const sessionExists = await Session.doesSessionExist();

        if (!sessionExists) {
            await Session.attemptRefreshingSession();
        }
    } catch (error) {
        if (!environment.production) {
            console.warn('SuperTokens bootstrap refresh failed', error);
        }
    }
}
